import { Component, Inject, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { AuthService } from 'src/app/service/auth.service';
import { CommonService } from 'src/app/service/common.service';
import { GSMConfigurationService } from 'src/app/Service/gsmconfiguration.service';
import { GenericValidator } from 'src/app/validation/general-validation';

@Component({
  selector: 'app-edit-virtual-meter',
  templateUrl: './edit-virtual-meter.component.html'
})
export class EditVirtualMeterComponent implements OnInit {
  Formula: string = '';
  isForViewFormula: boolean = false;
  isDisplayFormula: boolean = false;
  ParameterList: any = [];
  parameterconfigform: FormGroup;
  EnergyMeterList = [];
  errorMsg: string = '';
  successMsg: string = '';
  meterId: any = '';
  EnergymeterName: any;
  RegisterData: any;
  displayMessage: { [key: string]: string } = {};
  private genericValidator: GenericValidator;
  private validationMessages: { [key: string]: { [key: string]: string } };
  ParameterConfigId: any;
  RegisterName: any;
  TempFormula: any;
  TagId: any;
  title: any = 'Parameter Configuration';
  Register: any;
  selectedmetername: any
  meterid: any
  IsFromParameterConfig: any
  getallmeterlist: any;
  mainregisterlist: any;
  isdatacount: boolean;
  RegisterData1: any;
  selectedregister: any;
  constructor(public dialogRef: MatDialogRef<EditVirtualMeterComponent>, private commonservice: CommonService, private GSMConfigService: GSMConfigurationService, private formBuilder: FormBuilder, private authService: AuthService, @Inject(MAT_DIALOG_DATA) public data: any) {

    this.selectedregister = data.selectedregister
    this.selectedmetername = data.selectedmetername
    this.meterid = data.id
    if (data && data.IsForview == 'Y') {
      this.isForViewFormula = true;
      this.Formula = data.Formula;
      this.title = 'View Formula';
    }
    if (data && data.IsForview == 'N') {
      this.ParameterConfigId = this.data.data;
      this.RegisterName = this.ParameterConfigId ? this.ParameterConfigId.value.RegisterName : this.data.data.RegisterName;
      this.TempFormula = this.ParameterConfigId ? this.ParameterConfigId.value.TempFormula : this.data.data.TempFormula;
      this.TagId = this.ParameterConfigId ? this.ParameterConfigId.value.TagId : this.data.data.TagId
      this.title = 'Parameter Configuration';
    }
    this.authService.getValidationMessage().subscribe(resp => {
      this.validationMessages = resp.parameterconfigform;
      this.genericValidator = new GenericValidator(this.validationMessages);
    });
  }

  ngOnInit(): void {
    if (this.data.data.value) {
      this.isDisplayFormula = true;
    }
    this.getEnergyMeterData();
    this.meterId = this.meterid;
    this.EnergymeterName = this.selectedmetername;
    this.parameterconfigform = this.formBuilder.group({
      RegisterDataId: ['', [Validators.required]],
      MeterId: [''],
      Formula: [''],
      RegisterName: ['']
    });

    if (this.ParameterConfigId.value.RegisterNO > 0) {
      this.isDisplayFormula = true;
    }

    if (!this.data.datalist.value || this.data.datalist.value.length == 0 || this.data.datalist.value == undefined || this.data.datalist.value == null || this.data.datalist.value == " ") {
      this.VirtualFormulaData()
    }
    else {
      this.parameterconfigform.patchValue({ Formula: this.data.data.value.Formula })
      this.ParameterList = []
      this.data.datalist.value.forEach(element => {
        this.ParameterList.push(element)
      });
    }
  }

  // Function to fetch register list that is connected to this virtual register
  VirtualFormulaData() {
    if (this.selectedregister) {
      this.GSMConfigService.GetVirtualFormulaData(this.selectedregister.value).subscribe(
        (result) => {
          this.parameterconfigform.patchValue({ Formula: this.data.data.value.Formula })
          this.ParameterList = []
          result.forEach(element => {
            this.ParameterList.push(element)
          });
        },
        (error) => {
          this.errorMsg = error;
        }
      );
    }
  }

  // To fetch all meter list to bind data in meter list dropdown
  getEnergyMeterData() {
    this.commonservice.GetEnergyMeterIdList(0, 0, 'N').subscribe(
      (result) => {
        this.EnergyMeterList = result;
        this.EnergyMeterList = this.EnergyMeterList.filter((e: any) => e.DeviceType != 3)
        if (this.meterId) {
          this.EnergyMeterList.forEach(option => {
            if (this.meterId == option.CodeValue) {
              option.isDisabled = false;
            }
            else {
              option.isDisabled = true;
            }
          });
        }
      },
      (error) => {
        this.errorMsg = error;
      }
    );
  }

  // Delete Icon click function
  DeleteParamterData(index: number) {
    this.errorMsg = '';
    this.successMsg = '';
    // Remove the selected item
    this.ParameterList.splice(index, 1);

    // Reassign RegisterNo dynamically as PC1, PC2, ...
    this.ParameterList.forEach((param, i) => {
      param.RegisterNo = 'PC' + (i + 1);
    });

    // Re-enable all energy meters if list is empty
    if (this.ParameterList.length == 0) {
      this.EnergyMeterList.forEach(option => {
        option.isDisabled = false;
      });
    }
  }

  OnChangeRegister(event) {
    this.Register = event.source.triggerValue
  }

  // Formula validation function
  CheckForFormula(Formula: string) {

    // Match all occurrences like PC1, PC2, etc.
    const matches = Formula.match(/PC\d+/g) || [];

    // Create a Set for uniqueness
    const uniquePCs = [...new Set(matches)];

    // Compare against ParameterList
    const paramRegisterNos = this.ParameterList.map(p => p.RegisterNo);

    // Check if all ParameterList PCs are present in the formula
    const missingRegisters = paramRegisterNos.filter(pc => !uniquePCs.includes(pc));

    if (uniquePCs.length > paramRegisterNos.length) {
      this.errorMsg = "Formula Invalid, Please enter valid formula.";
      return;
    } else if (missingRegisters.length > 0) {
      this.errorMsg = 'Include all the registers or delete them from the list if not needed';
      return;
    }

    this.errorMsg = ''; // No errors
  }

  // Get Register Data based meter id
  GetRegisterdata(id) {
    if (id != null) {
      this.GSMConfigService.GetRegisterdata(id, 'N', '', '').subscribe(
        (result) => {
          if (result.listRegisterdata != null) {
            this.RegisterData = result.listRegisterdata;
            this.RegisterData.forEach(option => {
              if (option.TagId == "DataCount") {
                option.isDisabled = true;
              }
            });
          }
        },
        (error) => {
          this.errorMsg = error;
        }
      );
    }
  }

  // Close Icon event
  Close() {
    this.dialogRef.close();
  }

  // Click on Add Button function
  AddRegisters() {
    this.errorMsg = '';
    this.successMsg = '';
    var selectedmeter = this.parameterconfigform.value.MeterId;
    var selectedreg = this.parameterconfigform.value.RegisterDataId;
    // Find the selected meter and register from the list
    var tempmeter: any[] = this.EnergyMeterList.filter((item: any) => item.CodeValue == selectedmeter);
    var tempregister: any[] = this.RegisterData.filter((item: any) => item.RegisterDataId == selectedreg);

    var PCindex = 0;
    if (this.ParameterList == null) {
      PCindex = 1;
    }
    else {
      PCindex = this.ParameterList.length + 1;
    }

    // New object to be added
    var newObj = {
      "RegisterName": tempregister[0].RegisterName,
      "TagID": tempregister[0].TagId,
      "EnergymeterId": tempmeter[0].EnergymeterId,
      "MeterName": tempmeter[0].CodeDisplayText,
      "RegisterDataId": selectedreg,
      "MeterDataId": selectedmeter,
      "RegisterNo": 'PC' + PCindex,
      "VirtualRegisterId": this.data.data.value.RegisterDataId
    };

    // Check if the new entry already exists in ParameterList
    var existRegister = this.ParameterList ? this.ParameterList.filter((item: any) =>
      item.RegisterDataId == newObj.RegisterDataId &&
      // item.TagID == newObj.TagID &&
      item.MeterDataId == newObj.MeterDataId
    ) : [];

    if (existRegister.length > 0) {
      // If a matching entry exists, set the error message
      this.errorMsg = 'This register is already added in the list!';
    } else {
      // If no duplicate found, add the new object to the ParameterList
      if (!this.ParameterList) {
        this.ParameterList = [];
      }
      this.ParameterList.push(newObj);
      // this.successMsg = 'Register added successfully!';
    }
  }


  // Add Formula
  AddFormula() {
    this.isDisplayFormula = true;
  }

  // Save Parameter Config Data
  SaveParameterConfigData() {
    this.errorMsg = '';
    this.successMsg = '';

    var param = { ...this.parameterconfigform.value };

    var existRegisterName = this.ParameterList.filter(p => p.RegisterName == param.RegisterName);

    if (existRegisterName.length > 0) {
      this.errorMsg = 'Register Name already added against same MeterId. Please change Register Name!!';
      return;
    }
    this.CheckForFormula(param.Formula);

    this.parameterconfigform.controls['Formula'].setValidators(Validators.required);
    this.parameterconfigform.controls['Formula'].updateValueAndValidity();

    if (this.ParameterConfigId) {
      this.parameterconfigform.controls['RegisterDataId'].clearValidators();
      this.parameterconfigform.controls['RegisterDataId'].updateValueAndValidity();
    }

    if (this.parameterconfigform.invalid) {
      this.parameterconfigform.updateValueAndValidity();
      this.displayMessage = this.genericValidator.processMessages(this.parameterconfigform, true);
      return;
    }

    if (this.errorMsg == '') {
      var tagId = param.Formula;
      var registerFormula = param.Formula;
      this.ParameterList.forEach(element => {

        tagId = tagId.replaceAll(element.RegisterNo, '##' + element.TagId + '#');
        registerFormula = registerFormula.replaceAll(element.RegisterNo, '##' + (element?.TagID ? element?.EnergymeterId + "_" + element?.TagID : element?.RegisterName) + '#');
      });
      this.ParameterList.forEach(para => {
        const regExp = new RegExp(`\\b${para?.TagID ? para?.TagID : para?.RegisterName}\\b`, 'g');
        registerFormula = registerFormula.replace(
          regExp,
          para.EnergymeterId + "_" + (para?.TagID ? para?.TagID : para?.RegisterName)
        );
      });
      var reqObj = {
        RegisterDataId: this.ParameterConfigId ? this.ParameterConfigId : 0,
        EnergymeterMasterId: this.meterId,
        TagId: registerFormula,
        Formula: param.Formula,
        TempFormula: null,
        IsFromParameterConfig: "Y",
        PCNo: this.ParameterList,
        VirtualRelationdetails: this.ParameterList
      };
      this.dialogRef.close(reqObj)
    }
  }

  OnChangeEnergymeter(event) {

    this.parameterconfigform.patchValue({
      MeterId: event.value
    });
    this.meterId = event.value;
    this.EnergymeterName = event.source.triggerValue;
    this.GetRegisterdata(this.meterId);
  }
  OnChangeRegisterName(event) {
    var TagId = this.RegisterData.filter(event => event.RegisterDataId == this.parameterconfigform.value.RegisterDataId)[0].TagId;
    this.RegisterData.forEach(option => {
      if (TagId == 'DataCount') {
        this.isdatacount = true;
        if (option.TagId != 'DataCount') {
          option.isDisabled = true;
        } else {
          option.isDisabled = false;
        }
      } else {
        this.isdatacount = false;
        if (option.TagId == 'DataCount') {
          option.isDisabled = true;
        } else {
          option.isDisabled = false;
        }
      }

    });
  }
}
